import React from 'react'
import SendMailPage from '../EmailTemp/SendMailPage'

const About = () => {
  return (
    <div>
    
    <SendMailPage/>
    
    </div>

  )
}

export default About